import { ROLES } from "../constants/roles";

export const getPolicyData = () => {
  const policyData = localStorage.getItem("policyData");
  const isOcasoPolicyString = localStorage.getItem("loggedUser") || "{}";
  const isOcasoPolicyObj = JSON.parse(isOcasoPolicyString);
  const isOcasoPolicy =
    isOcasoPolicyObj &&
    isOcasoPolicyObj.roles &&
    Array.isArray(isOcasoPolicyObj.roles)
      ? isOcasoPolicyObj.roles.includes(ROLES.OCASO)
      : false;
  return policyData
    ? { ...JSON.parse(policyData), isOcasoPolicy }
    : { isOcasoPolicy };
};


export const checkSendaWarnings = (response: any) => {
  let warns : string[] = []
  if (response && response.warnings) {
    Object.keys(response.warnings).forEach((warningType: string) => 
      response.warnings[warningType].forEach((r: any) => {r.message && warns.push(r.message)})
    )
  }
  return {
    noAutWarnings: response && !!response.warnings 
      && !!response.warnings['avisos_noaut']
      && !!response.warnings['avisos_noaut'].length,
    warnList: warns,
  }
}

export const getProductHiringLink = (product: any) => {
  const [pathname, params] = product && product.products_link && product.products_link.split('?');

  return {
    pathname,
    params
  }
}